// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1mdsW","savePackageButton":"ClientWallet_savePackageButton__3pVg5"};